__turbopack_context__.v({
  "backgroundLayer": "Banner-module__kdKZJW__backgroundLayer",
  "blurredCard": "Banner-module__kdKZJW__blurredCard",
  "buttons": "Banner-module__kdKZJW__buttons",
  "caption": "Banner-module__kdKZJW__caption" + " " + __turbopack_context__.i(263274)["bannerCaption"],
  "content": "Banner-module__kdKZJW__content",
  "contentColumn": "Banner-module__kdKZJW__contentColumn",
  "foregroundImageWrapper": "Banner-module__kdKZJW__foregroundImageWrapper",
  "note": "Banner-module__kdKZJW__note",
  "sectionContent": "Banner-module__kdKZJW__sectionContent",
  "subtitle": "Banner-module__kdKZJW__subtitle" + " " + __turbopack_context__.i(263274)["bannerSubtitle"],
  "textStack": "Banner-module__kdKZJW__textStack",
  "title": "Banner-module__kdKZJW__title" + " " + __turbopack_context__.i(263274)["bannerTitle"],
});
